import React from 'react'
import { useTranslation } from 'react-i18next'
import HeroSection from './heroSection'
import Seo from './Seo'
import StoryGrid from './StoryGrid'
import Pagination from './Pagination'
import Cta from './CTA'
import Faq from './faq'
import Testimonials from './testimonialsDynamic'
import SpicinessTiles from './SpicinessTiles'
import TagSliderWave from './TagSliderWave'

const LandingpageLayout = (props) => {
  const { t } = useTranslation()
  const { 
    pageHeadline, 
    pageDescription, 
    metaHeadline, 
    metaDesc, 
    stories, 
    currentPage, 
    numPages, 
    cta = t('root.ctaText-1'), 
    testimonials = t('root.testimonials'),
    faq = t('root.faq'),
    faqTitle = t('root.faqSectionTitle'),
    tagShowAllLink, 
    tags, 
    paginationUrl,
    tagSliderTitle,
    imageUrl
    } = props

  const randomStory = React.useMemo(() => stories[Math.floor(Math.random() * stories.length)], [stories]);
  return (
    <>
      <HeroSection title={pageHeadline} text={pageDescription}/>
      <Seo title={metaHeadline} description={metaDesc} image={imageUrl}/>
      <StoryGrid stories={stories}/>
      {paginationUrl && <Pagination currentPage={currentPage} numPages={numPages} url={paginationUrl}/>}
      <Cta text={cta}/>
      {faq && ( <Faq title={faqTitle} content={faq} randomStory={randomStory}/>)}
      <Testimonials testimonials={testimonials} stories={stories}/>
      <SpicinessTiles/>
      <TagSliderWave showAllLink={tagShowAllLink} tags={tags} title={tagSliderTitle}/>
    </>
  )
}

export default LandingpageLayout